export const dayAheadMarketMenuName = 'Menu::MenuG:DayAhead';
export const forwardPhysicalMarketMenuName = 'Menu::MenuG:Fpm';
